import { Droppable } from '@hello-pangea/dnd';
import { Control, FieldArrayWithId, UseFormRegister } from 'react-hook-form';

import { type InquiryForm } from '../../../models/Inquiry/Inquiry';
import FormContentItem from './FormContentItem';

interface Props {
  droppableId: string
  fields: Array<FieldArrayWithId<InquiryForm, 'definition', 'id'>>
  register: UseFormRegister<InquiryForm>
  control: Control<InquiryForm, any>
  onRemove: (id: number) => void
  disabled: boolean
  sideContent?: JSX.Element
}

export default function FormContent({
  droppableId,
  fields,
  control,
  register,
  onRemove,
  disabled,
  sideContent = null,
}: Props): JSX.Element {
  return (
    <>
      <div className="fw-bold mb-1">
        <span>＜表示項目＞</span>
        <span className="label-required mx-2">必須</span>

        {sideContent && (
          <span className="float-end">
            {sideContent}
          </span>
        )}
      </div>
      <Droppable droppableId={droppableId}>
        {(provided, snapshot) => (
          <div
            ref={provided.innerRef}
            className={`webdb-list-viewitems flex-fill ${snapshot.isDraggingOver ? 'bg-light' : ''}`}
          >
            {/* 項目が空の場合 */}
            {
              fields.length === 0 && (
                <div className="list-group gap-1 justify-content-center user-select-none h-100">
                  <div className="align-self-center opacity-50">項目をドラッグ＆ドロップ</div>
                </div>
              )
            }
            {/* 項目が有りの場合 */}
            <div className="list-group gap-1 justify-content-center">
            {fields?.map((item, index) => (
              <FormContentItem
                key={item.uuid}
                item={item}
                index={index}
                register={register}
                control={control}
                onRemove={onRemove}
                disabled={disabled}
              />
            ))}
            </div>
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </>
  );
}
